export const formatCurrency = (
  number: number,
  maximumFractionDigits = 2
): string =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits,
  }).format(number);
